var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.47 5.396a.548.548 0 00-.445-.37l-3.875-.53L7.5.826A.547.547 0 007 .5v10.983l3.385 1.945a.548.548 0 00.59-.03.554.554 0 00.225-.545l-.715-4.041 2.855-2.85a.56.56 0 00.13-.566z",
    fill: "#D1D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.998.5a.547.547 0 00-.5.325L4.848 4.49l-3.875.535a.55.55 0 00-.31.935l2.855 2.85-.72 4.045c-.04.21.05.42.225.545a.548.548 0 00.59.03l3.385-1.95V.5z",
    fill: "#F59600"
  })));
}

export default SvgIconStarHalf;